export const environment = {
  api_url: 'https://$customer_subdomain$.2.stage.businesscenter.tangoe.com/store/api/v1'
};
